import React from "react";

import { MdmAntennaDto } from "gql/generated/types";
import { Dialog } from "primereact/dialog";
import { T } from "services/lang/LanguageService";
import AntennaForm from "./AntennaForm";

type AntennaFormDialogProps = {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  antenna?: MdmAntennaDto;
};

const AntennaFormDialog: React.FC<AntennaFormDialogProps> = ({ showDialog, setShowDialog, antenna }) => {
  return (
    <Dialog
      header={T("mdm.antenna")}
      visible={showDialog}
      onHide={() => setShowDialog(false)}
      style={{ width: "min(100vw, 1000px)", height: "400x" }}
      resizable
      modal
    >
      <AntennaForm closeDialog={() => setShowDialog(false)} antenna={antenna} newForm={!antenna} />
    </Dialog>
  );
};

export default AntennaFormDialog;
